import React, { useState, useEffect } from "react"
import subscriptionContainer from "container/BrokerDashboard/subscriptionContainer"
import { Spin } from "antd"
import {
  WhiteButton,
} from "../../commonStyles"

const CopyOnboardingURL = ({
  disabled,
  copyOnboardingURLResponse,
  copyOnboardingURL,
  currentAgentIDViewed,
}) => {
  const {
    data: fetchedUrl,
    isFetching: fetchingURL,
    isError: fetchError,
  } = copyOnboardingURLResponse || {}

  const [copyState, setCopyState] = useState(false)

  useEffect(() => {
    if (!fetchingURL && copyState) {
      const timer = setTimeout(() => setCopyState(false), 2000)
      return () => clearTimeout(timer)
    }
  }, [fetchingURL, copyState])

  return (
    <WhiteButton
      onClick={() => {
        copyOnboardingURL({
          agentId: currentAgentIDViewed,
        })
        setCopyState(true)
      }}
      ATCFONT
      disabled={disabled || fetchingURL}
      borderRadius="33.5px"
      style={{
        padding: "7px 12px",
        minWidth: "240px",
        whiteSpace: "nowrap",
      }}
    >
      {fetchingURL ? (
        <>
          <Spin size="small" style={{ marginRight: 8 }} />
          Copying URL...
        </>
      ) : copyState && fetchedUrl ? (
        "Copied!"
      ) : (
        "Copy/Regenerate Onboarding URL"
      )}
    </WhiteButton>
  )
}

export default subscriptionContainer(CopyOnboardingURL)

